import React, { Suspense } from 'react';
import { Route, Switch, Redirect, BrowserRouter as Router } from 'react-router-dom';
import { Progress, Header } from 'react-design-components';
import { Loading } from 'react-commons';
import { IRouteProps } from '../../types';
import routes from '../../routes';
import useEntrypoint from './hooks/useEntrypoint';
import usePureApp from './hooks/usePureApp';
interface EntrypointProps {
  defaultRoute: string | undefined;
}

const PureApp: React.FC<EntrypointProps> = ({ defaultRoute }: EntrypointProps) => {
  const { appStore, headerLogo, getRouteComponent, logoOnClick } = usePureApp({ defaultRoute });

  const routeComponent = (route: IRouteProps) =>
    route.isDefault && defaultRoute
      ? ({ location }: { location: Location }) => (
          <Redirect
            to={{
              // this is to preserve query params
              ...location,
              pathname: defaultRoute,
            }}
          />
        )
      : () => getRouteComponent(route);
  return (
    <Router basename={process.env.REACT_APP_ORDER_URL}>
      <Suspense fallback={<Loading />}>
        <Header logoOnClick={logoOnClick} logo={headerLogo} />
        {appStore.progress && <Progress value={Number(appStore.progress)} />}
        <Switch>
          {routes.map((route: IRouteProps) => (
            <Route key={`route-${route.path}`} path={route.path} component={routeComponent(route)} />
          ))}
        </Switch>
      </Suspense>
    </Router>
  );
};

const Entrypoint: React.FC<EntrypointProps> = ({ defaultRoute }: EntrypointProps) => {
  useEntrypoint();
  return <PureApp defaultRoute={defaultRoute} />;
};

export default Entrypoint;
export type { EntrypointProps };
